import { Component, EventEmitter, Input, Output, AfterViewInit } from '@angular/core';
import { Constant, BaseComponent, DatePickerFormatter } from 'app/infrastructure/common/index';
import { OnlineShippingNoticeService } from 'app/infrastructure/services/transaction/op/inbound/asn/online-shipping-notice.service';
import { AdvancedShippingNotice} from 'app/data/models/transaction/op/inbound/asn';
import { UserProductConfigModel} from 'app/data/models/master/op';
import { ProductConfigService } from 'app/infrastructure/services/master/wm';
import {LazyLoadEvent} from 'primeng/primeng';

import * as _ from 'lodash';
import * as moment from 'moment';
import { validateConfig } from '@angular/router/src/config';


declare var jQuery: any;

@Component({
    selector: 'app-asn-select-products',
    templateUrl: './select-products.html',
    styleUrls: ['./select-products.css']
})
export class ASNSelectProductsComponent extends BaseComponent implements AfterViewInit {
  @Output() goBackEvent = new EventEmitter<any>();
  @Output() goToFirstEvent = new EventEmitter<any>();
  @Output() asnSummaryEvent = new EventEmitter<any>();
  

  @Input() ownerCode: string;
  @Input() asn: AdvancedShippingNotice;

  searchParams:any = {};
  products:any[] = [];
  productTotalRecords:number = 0;
  selectedChkAllProd: boolean = false;
  isLoading:boolean = false;

  isZeroProduct:boolean = false;
  isZeroQty:boolean = false;
  isZeroUom:boolean = false;

  ownerConfig: UserProductConfigModel = new UserProductConfigModel();
  
  selectedAsnLine: any = {};

  constructor(private onlineShippingNoticeService : OnlineShippingNoticeService,
    private productConfigService: ProductConfigService){
    super();
  }

  ngOnInit(): void {    
    this.loadOwnerConfig();
  }

  showDatePicker(idEl) {    
    this.initDatePicker();
    jQuery('#' + idEl).datepicker('show');
  }

  ngAfterViewInit(): void {
    this.initDatePicker();
  }

  initDatePicker(){
    var self = this;
    jQuery('.mydatepicker').datepicker({
        autoclose: true,
        clearBtn: true,
        format: DatePickerFormatter.mapDateFormat(this.token.DateFormatDescription),                      

    }).on('show', (e) => {
        
    }).on('change', (e) => {            
        let splitted = e.target.id.split("_", 2);
        let lineIndex = splitted[1];
        let inputId = splitted[0];
        
        switch(inputId){

          case "textExpiryDate":
            self.asn.OnlineShippingNoticeLines[lineIndex].ExpiryDateString = e.target.value;
          break;
          case "textProductionDate":
            self.asn.OnlineShippingNoticeLines[lineIndex].ProductionDateString = e.target.value;
          break;              
        }
    });
  }

  loadProductLazy(event: LazyLoadEvent){
    let self = this;
    self.searchParams.OwnerCode = self.ownerCode;
    self.searchParams.ProdCode = event.filters.ProductCode != undefined ? event.filters.ProductCode.value : null;
    self.searchParams.Description = event.filters.Description != undefined ? event.filters.Description.value : null;
    self.searchParams.PageSize = event.rows;
    self.searchParams.Page = (event.first / event.rows) + 1;
    this.onlineShippingNoticeService.requestGetProducts(self.searchParams)
      .subscribe(data => {
        let message = data;
        if (message && message.MessageType && message.MessageType.Value) {
          if (message.MessageType.Value == Constant.MessageType.success) {
            if(self.asn.OnlineShippingNoticeLines.length > 0){
              for(let item of self.asn.OnlineShippingNoticeLines){
                let index = message.Result.findIndex(d=>d.ProductCode === item.ProductCode);
                if(index >= 0)
                  message.Result.splice(index,1);
              }
            }
              self.products = message.Result;
              self.productTotalRecords = message.TotalRecords;
          }
          else {
            self.showAlert(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
          }
        }
        else {
          self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, null);
        }
      },
        error => {
          self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
      });
  }
  selectAllProducts(isSelected: boolean) {
    _.forEach(this.products, function (value, index, coll, addPar = { "isSelected": isSelected }) {
      value.isSelected = addPar.isSelected;
    });
  }
  add() {
    let self = this;
    self.selectedChkAllProd = false;
    let items = [];
    for (let item of self.products) {
      if(item.isSelected){
        self.asn.OnlineShippingNoticeLines.push(item);
        items.push(item);    
      }
    }
    for(let item of items){
      self.products.splice(self.products.indexOf(item),1);
    }
    jQuery("#myModal").modal("hide");
  }
  validate(){
    if(this.asn.OnlineShippingNoticeLines.length == 0)
      this.isZeroProduct = true;
    else
      this.isZeroProduct = false;
    if(this.asn.OnlineShippingNoticeLines.map(function(e) { return e.Qty; }).includes(0))
      this.isZeroQty = true;
    else
      this.isZeroQty = false;
    if(this.asn.OnlineShippingNoticeLines.map(function(e) { return e.UomCode; }).includes(undefined))
      this.isZeroUom = true;
    else
      this.isZeroUom = false;
  }
  completeForm(){
    this.asn.DateFormat = this.token.DateFormatDescription;
    this.asn.WhsCode = this.token.DefaultWarehouseCode;
    this.asn.OwnerCode = this.ownerCode;
    this.asn.CreatedBy = this.token.UserId;
    this.asn.UpdatedBy = this.token.UserId;
}
  save(isDraft:boolean){
    let self = this;
    self.validate();
    if(!this.isZeroProduct && !this.isZeroQty && !this.isZeroUom){
      self.completeForm();
      let oldStatus = self.asn.StatusCode;
      self.isLoading = true;
      self.asn.StatusCode = isDraft ? Constant.OnlineShippingNoticeStatus.draft : Constant.OnlineShippingNoticeStatus.new;
      self.onlineShippingNoticeService.saveOnlineShippingNotice(self.asn)
      .subscribe(
          data => {
              self.isLoading = false;
              let message = data;
              if (message && message.MessageType && message.MessageType.Value) {
                  self.showMessage(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
                  if (message.MessageType.Value == Constant.MessageType.success) {
                      self.asn = message.Result;
                      self.goToFirstEvent.emit();
                  }else
                    self.asn.StatusCode = oldStatus;
              }
              else {
                  self.asn.StatusCode = oldStatus;
                  self.showMessage(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError);
              }
          },
          error => {
              self.isLoading = false;
              self.asn.StatusCode = oldStatus;
              self.showMessage(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
          });
    }
  }
  canSaveAsDraft(): boolean {
    return (this.asn.OopAsnNo == null || this.asn.StatusCode == Constant.OnlineShippingNoticeStatus.draft);
  }
  delete(data:any) {
    data.isSelected = false;
    
    this.products.push(data);

    let index = this.asn.OnlineShippingNoticeLines.indexOf(data);
    this.asn.OnlineShippingNoticeLines.splice(index, 1);
    
    this.products.sort(this.compareValues("ProductCode","asc"));

    this.selectedAsnLine = null;

    jQuery('#PopupConfirm').modal("hide");
  }

  showDeleteConfirmation(selectedAsnLine: any) {    
    this.selectedAsnLine = selectedAsnLine;
    jQuery('#PopupConfirm').modal("show");
  }

  goBack(){
    this.goBackEvent.emit();
  }
  showMessage(title: string, messageNumber: string, message: string, additionalInfo: string = null) {
    jQuery('#PopupMessageTitle').html(title);
    jQuery('#PopupMessageContent').html('(' + messageNumber + ') ' + message + (additionalInfo ? ' -- ' + additionalInfo : ''));
    jQuery('#PopupMessage').modal('show');
  }

  showAlert(title: string, messageNumber: string, message: string, additionalInfo: string = null) {
    alert(title + ': (' + messageNumber + ') ' + message + '--' + (additionalInfo ? ' -- ' + additionalInfo : ''));
  }
  compareValues(key:string, order:string="asc") {
    return function(a, b) {
      if(!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
        // property doesn't exist on either object
        return 0;
      }
  
      const varA = (typeof a[key] === 'string') ?
        a[key].toUpperCase() : a[key];
      const varB = (typeof b[key] === 'string') ?
        b[key].toUpperCase() : b[key];
  
      let comparison = 0;
      if (varA > varB) {
        comparison = 1;
      } else if (varA < varB) {
        comparison = -1;
      }
      return (
        (order == 'desc') ? (comparison * -1) : comparison
      );
    };
  }

  submit() {
    // this.save();
    //this.onSubmitSelectProduct(blue[]);
    // this.onSubmitSelectProduct.emit(this.orderLineModels);
    this.asnSummaryEvent.emit(this.asn);
  }

  validateForm() {
    return this.asn.OnlineShippingNoticeLines && this.asn.OnlineShippingNoticeLines.length > 0 && !this.asn.OnlineShippingNoticeLines.map(function(e) { return e.Qty; }).includes(0) && !this.asn.OnlineShippingNoticeLines.map(function(e) { return e.UomCode; }).includes(undefined);
  }

  isHidden(isVisible: boolean): boolean {
    return (isVisible != true);
  }

  loadOwnerConfig(): void {
    let self = this;

    let ownerCode = self.asn.OwnerCode;

    self.productConfigService.getOwnerConfig(ownerCode)
      // this.productConfigService.getOnlineUserProductConfigByUserOwner(this.token.UserId, ownerCode)
      .subscribe(
      data => {
        self.isLoading = false;

        let message = data;
        if (message && message.MessageType && message.MessageType.Value) {
          if (message.MessageType.Value == Constant.MessageType.success) {
            self.ownerConfig = message.Result;
          }
          else {
            self.showAlert(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
          }
        }
        else {
          self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, null);
        }
      },
      error => {
        self.isLoading = false;
        self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
      }
      )
  }  
}



// WEBPACK FOOTER //
// ./src/app/views/pages/transaction/op/inbound/asn/submit-asn/select-products/select-products.component.ts